import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { AuthService } from '../http/auth.service';
import { FuncionesService } from '../funciones.service';
import { Injectable } from '@angular/core';
import { UiService } from '../ui/ui.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor(
    private authSrv: AuthService,
    private ui: UiService,
    private funSrv: FuncionesService
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {    
      return next.handle(request).pipe(catchError(err => {
        if(err.status === 401){
          if(err.url.includes('api/cerrarSesion')){
            this.authSrv.cleanUser();
          }else{
            this.authSrv.cerrarSesion();
          }
        }else if( err.status >= 512 && err.status <= 518 ){ 
          this.ui.showAlert( 'Sesión', this.funSrv.validarErrorSesion( err ), 'error'  );
          this.authSrv.cerrarSesion();
        }else if(err.status === 403){
          this.ui.showAlert('Acción no permitida.', 'La acción solicitada no puede ejecutarse.' , 'error')
        }
        return throwError(() => err);
      }))
  }
}
